/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LabelPrintInfo } from '../../models/label-print-info';
import { LabelType } from '../../models/label-type';

export interface GetPrintInfo$Params {
  productionOrderId: number;
  labelType?: LabelType;
}

export function getPrintInfo(http: HttpClient, rootUrl: string, params: GetPrintInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<LabelPrintInfo>> {
  const rb = new RequestBuilder(rootUrl, getPrintInfo.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.query('labelType', params.labelType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LabelPrintInfo>;
    })
  );
}

getPrintInfo.PATH = '/api/v1/PrintLabel/{productionOrderId}/PrintInfo';
